// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"8d1aaf17","240":"a4adeb27","368":"7524d91b","453":"97b56695","470":"06b4fc5b","489":"0e4a7ee9","501":"c250a281","559":"cc800e6f","671":"0f60e655","703":"bbc2a14b","807":"83fb131e","833":"05c0a91d","847":"f3919c33"}[chunkId] + ".chunk.js";
};